export const SET_MESSAGING_USER = "SET_MESSAGING_USER";
export const SET_MESSAGES_IN_VIEW = "SET_MESSAGES_IN_VIEW";
export const SET_CHATS = "SET_CHATS";
export const SET_CHATS_FILTER_VAL = "SET_CHATS_FILTER_VAL";
